export default __webpack_public_path__ + "static/media/ic-timer-delay.51348163.svg";